import {Dispatch, SetStateAction, useEffect} from 'react';
import {Edge, OnEdgesChange, useEdgesState} from 'reactflow';

import {ProcedureRunDesignFlowchartEdgeData} from './ProcedureRunDesignFlowchartEdge';

export type ProcedureRunDesignFlowchartLayoutEdge = Edge<ProcedureRunDesignFlowchartEdgeData>;

export interface UseProcedureRunDesignFlowchartEdgesArgs {
  initialEdges: Array<ProcedureRunDesignFlowchartLayoutEdge>;
}

export interface UseProcedureRunDesignFlowchartEdgesResult {
  edges: Array<ProcedureRunDesignFlowchartLayoutEdge>;
  setEdges: Dispatch<SetStateAction<Array<ProcedureRunDesignFlowchartLayoutEdge>>>;
  onEdgesChange: OnEdgesChange;
}

/**
 * Owns the ReactFlow edge state for the procedure run design flowchart and keeps it in sync as the
 * underlying edge specs change.
 */
export function useProcedureRunDesignFlowchartEdges({
  initialEdges,
}: UseProcedureRunDesignFlowchartEdgesArgs): UseProcedureRunDesignFlowchartEdgesResult {
  const [edges, setEdges, onEdgesChange] = useEdgesState<ProcedureRunDesignFlowchartEdgeData>(initialEdges);

  useEffect(() => {
    setEdges(initialEdges);
  }, [initialEdges, setEdges]);

  return {edges, setEdges, onEdgesChange};
}
